import React from 'react';
import getStyles from './styles';
import { ProjectViewPage } from '../../../components';

const OpenInnovationPage = () => {
  const styles = getStyles();
  return (
    <ProjectViewPage
      // heroTitle="A Feature-Rich App Built for"
      // heroGradientText="Networking and Navigation"
      infoLabel1="Client"
      infoLabel2="Services"
      infoLabel3="Deliverables"
      infoLabel4="Tech Stack"
      client="Open Innovation"
      services={['UX/UI Design', 'Full Stack Development']}
      deliverables={['Mobile Application', 'CMS Dashboard']}
      techStack={['React Native', 'Node.js', 'Express']}
      clientLogo="/images/startup-white.png"
      infoLabel5="Website"
      visitWebsite="Visit Site"
      website="https://www.openinnovation.startuptn.in/"
      overviewTitle="Overview"
      // approachTitle="Approach"
      heroImage="/images/openinnovation-first.png"
      overviewImage="/images/openinnovation-first.png"
      approachImage="/images/openinnovation-full-1.png"
      overviewDescription={[
        'The Open Innovation Portal, an initiative by StartupTN, serves as a dynamic platform that connects startups with corporates, research institutions, and government agencies to co-create impactful solutions. It acts as a catalyst for collaboration, enabling organizations to identify innovative startups capable of addressing real-world challenges with agility and creativity. By bridging the gap between industry needs and startup innovation, the portal accelerates the development of cutting-edge products and services that drive mutual growth and progress.'
      ]}
      approachDescription={[
        'Through this platform, corporates can access a pool of emerging innovators and startups across Tamil Nadu who bring fresh ideas, disruptive technologies, and new business models to the table. Startups, in turn, gain the opportunity to work on high-impact industrial and societal problems, validate their solutions in real market environments, and scale with corporate mentorship and support. This two-way engagement fosters an ecosystem of shared learning, rapid prototyping, and result-driven innovation.',
        'The Open Innovation Portal empowers research institutions, corporates, and government bodies to collaborate seamlessly with startups and innovators, creating an environment where knowledge, technology, and entrepreneurship converge. By promoting open collaboration and inclusive innovation, the portal strengthens Tamil Nadu’s position as a hub for transformative ideas and industry-driven solutions. Whether you are a corporate seeking novel perspectives or a startup aspiring to make an impact, the Open Innovation Portal is your gateway to meaningful partnerships and sustainable innovation.'
      ]}
      heroContainerStyle={styles.container}
      commonSectionStyle={styles.section}
      heroSectionStyle={styles.heroSection}
      heroGradientStyle={styles.heroGradient}
      heroGlow1Style={styles.heroGlow1}
      heroGlow2Style={styles.heroGlow2}
      heroGlow3Style={styles.heroGlow3}
      containerWrapperStyle={styles.containerWrapper}
      heroImageContainerStyle={styles.heroImageContainer}
      phoneContainerStyle={styles.phoneContainer}
      phoneGlowStyle={styles.phoneGlow}
      phoneShadowStyle={styles.phoneShadow}
      heroPhoneStyle={styles.heroPhone}
      heroContentStyle={styles.heroContent}
      heroTitleStyle={styles.heroTitle}
      gradientTextStyle={styles.gradientText}
      infoCardStyle={styles.infoCard}
      infoItemStyle={styles.infoItem}
      infoLabelStyle={styles.infoLabel}
      primaryBadgeStyle={styles.primaryBadge}
      secondaryBadgeStyle={styles.secondaryBadge}
      badgesContainerStyle={styles.badgesContainer}
      accentBadgeStyle={styles.accentBadge}
      outlineBadgeStyle={styles.outlineBadge}
      overviewSectionStyle={styles.overviewSection}
      overviewGradientStyle={styles.overviewGradient}
      overviewGlowStyle={styles.overviewGlow}
      overviewGridStyle={styles.overviewGrid}
      overviewContentStyle={styles.overviewContent}
      sectionHeaderStyle={styles.sectionHeader}
      accentLineStyle={styles.accentLine}
      sectionTitleStyle={styles.sectionTitle}
      textContainerStyle={styles.textContainer}
      sectionTextStyle={styles.sectionText}
      overviewImageContainerStyle={styles.overviewImageContainer}
      overviewImageWrapperStyle={styles.overviewImageWrapper}
      overviewImageGlowStyle={styles.overviewImageGlow}
      overviewImageStyle={styles.overviewImage}
      approachSectionStyle={styles.approachSection}
      approachGradientStyle={styles.approachGradient}
      approachGlow1Style={styles.approachGlow1}
      approachGlow2Style={styles.approachGlow2}
      approachGridStyle={styles.approachGrid}
      approachContentStyle={styles.approachContent}
      // approachAccentLineStyle={styles.approachAccentLine}
      approachTitleStyle={styles.approachTitle}
      approachTextStyle={styles.approachText}
      scrollAreaStyle={styles.scrollArea}
      scrollContentStyle={styles.scrollContent}
      approachImageWrapperStyle={styles.approachImageWrapper}
      approachImageGlowStyle={styles.approachImageGlow}
      approachImageStyle={styles.approachImage}
    />
  );
};

export default OpenInnovationPage;
